module.exports = __webpack_public_path__ + "b1e76f30613cebedacae28cdd996d0bb.png";